import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c34c0ba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"20px"} }, "印章、证照刻制申请", -1))
const _hoisted_3 = { style: {"color":"#333"} }

import { ref, withDefaults, watch, computed } from "vue";
import { PLAINOPTIONS } from "@/const/home";


export default /*#__PURE__*/_defineComponent({
  props: {
    detail: { default: () => {
      return {
        PageData: { GsDocumentCollection: "" },
      };
    } }
  },
  setup(__props: any) {

const props = __props as { detail: {
      PageData?: { GsDocumentCollection?: string };
    } }


const GsDocumentCollection = computed(
  () =>
    (props.detail.PageData && props.detail.PageData.GsDocumentCollection) || ""
);

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_checkbox_group, {
      disabled: "",
      value: _unref(GsDocumentCollection)
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GsDocumentCollection), (item, index) => {
          return (_openBlock(), _createBlock(_component_a_checkbox, {
            key: index,
            class: _normalizeClass(index == 9 ? 'nomargin' : ''),
            value: item.toString()
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(PLAINOPTIONS)[item - 1]), 1)
            ]),
            _: 2
          }, 1032, ["class", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})